import { Injectable } from '@angular/core';

/**
 * Which SOR items have their description opened past the two-line clamp.
 *
 * The state has to outlive the cell. The board redraws rows whenever the preview highlight moves,
 * which destroys and rebuilds every renderer — a description the user opened would otherwise snap
 * shut on the next row click. Keyed by item id, so a redraw, a sort and a refetch all agree.
 */
@Injectable({ providedIn: 'root' })
export class SorDescriptionExpansionService {

  private readonly expanded = new Set<string>();

  public isExpanded(itemId: string): boolean {

    return this.expanded.has(itemId);
  }

  /** Absolute set — used when {@link ClampedTextComponent} owns the toggle UI. */
  public set(itemId: string, expanded: boolean): void {

    if (!itemId) return;
    if (expanded) this.expanded.add(itemId);
    else this.expanded.delete(itemId);
  }
}
